module.exports = __webpack_public_path__ + "img/MTABAPPDCBP.f09190f1.jpg";